/* eslint-disable */

import React from "react";
import { useState } from "react";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropCircleShareable from "../../../ui-components/raindrop-circle-shareable/raindrop-circle-shareable";
import RaindropInputFile from "../../../ui-components/raindrop-input-file/raindrop-input-file.tsx";

const NimbusSharecardsNew = () => {
  const [imageBackgroundURL, setImageBackgroundURL] = useState(null);
  const [imageForegroundURL, setImageForegroundURL] = useState(null);

  const onCreate = () => {
    console.log("(RD-4565) Creating sharecard, not yet implemented");
  };

  return (
    <div className="flex flex-row h-full w-full items-center justify-around text-center gap-2">
      <div
        className={`flex flex-col gap-4 max-w-lg w-full p-4 rounded-lg border
      dark:bg-color-dark-background-secondary bg-color-background-secondary
      dark:border-color-dark-border-tertiary border-color-border-tertiary
      `}
      >
        <div
          className={`w-full text-lg font-bold text-left 
        dark:text-color-dark-text-secondary text-color-text-secondary
        `}
        >
          Create a new Sharecard
        </div>

        <div>Background Image</div>
        <RaindropInputFile
          setImageUrl={setImageBackgroundURL}
          imageUrl={imageBackgroundURL}
        />

        <div>Foreground Image</div>
        <RaindropInputFile
          setImageUrl={setImageForegroundURL}
          imageUrl={imageForegroundURL}
        />

        <div className="flex flex-row w-full items-end justify-end">
          <RaindropButton
            title={"Create"}
            onClick={onCreate}
            style={ButtonStyle.Primary}
          />
        </div>
      </div>
      <div className="flex flex-col w-full max-w-lg bg-color-dark-background-tertiary h-full rounded-lg items-center justify-center">
        <RaindropCircleShareable
          urlBackground={imageBackgroundURL}
          urlForeground={imageForegroundURL}
        />
      </div>
    </div>
  );
};

export default NimbusSharecardsNew;
